module.exports = __webpack_public_path__ + "img/0-sm.511ea6eb.jpg";